import styled from "styled-components";

/** Standard screen-reader-only clip: present in the a11y tree, zero visual footprint. */
export const HiddenText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;
